<div class="container">
  @if (calendar$ | async; as calendar) {
  <mat-icon class="block-icon">block</mat-icon>
  <h2 i18n="@@CANCEL.CANCEL_MEETING">Cancel meeting</h2>
  <p class="subtitle" i18n="@@CANCEL.ABOUT_TO_CANCEL">
    You are about to cancel the following meeting
  </p>
  <ul class="meeting-info">
    <li>
      <span
        class="avatar"
        [ngStyle]="{
          'background-image':
            'url(' +
            (calendar.displayProfileUrl || './assets/images/profile.svg') +
            ')'
        }"
      ></span>
      <span data-testid="host-display-name" class="display-name">{{
        displayName ? displayName : calendar.displayName
      }}</span>
    </li>
    <li data-testid="cancel-confirmation-meeting-time">
      <mat-icon>watch_later</mat-icon>
      <span data-testid="meeting-length">
        {{
          meetingInfo?.startTime | date : 'h:mm a' : (timezoneOffset$ | async)
        }}
        -
        {{
          meetingInfo?.endTime | date : 'h:mm a' : (timezoneOffset$ | async)
        }},
        {{ meetingInfo?.startTime | date : 'fullDate' }}
      </span>
      <div class="timezone-container">
        <span>
          {{ meetingInfo?.timezone?.zone }} ({{
            meetingInfo?.timezone?.region
          }})
        </span>
      </div>
    </li>
    <li>
      @if ((meetingLocation$ | async); as location) {
      <span class="in-person-location">
        <mat-icon>location_on</mat-icon>
        <span
          data-testid="meeting-location"
          [matTooltip]="location"
          [class.truncated]="location.length > 50"
        >
          {{
            location.length > 50
              ? (location | slice : 0 : 50) + '...'
              : location
          }}
        </span>
      </span>
      }
    </li>
  </ul>
  <p class="footer"></p>
  <div class="action-area">
    <mat-form-field class="cancellation-reason" appearance="fill">
      <mat-label i18n="@@CANCEL.REASON_FOR_CANCELLING">
        Reason for cancelling (optional)
      </mat-label>
      <textarea
        matInput
        [(ngModel)]="cancellationReason"
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="5"
      ></textarea>
    </mat-form-field>
    <div class="buttons">
      <button
        mat-button
        color="primary"
        (click)="rescheduleMeeting()"
        i18n="@@CANCEL.RESCHEDULE_INSTEAD"
      >
        Reschedule instead
      </button>
      <button
        mat-raised-button
        color="warn"
        (click)="cancelMeeting()"
        data-testid="cancel-button"
        i18n="@@CANCEL.CANCEL_MEETING"
      >
        Cancel meeting
      </button>
    </div>
  </div>
  @if (error) {
  <div>
    <mat-icon color="warn" class="error">error_outline</mat-icon>
    <ng-container i18n="@@CANCEL.PROBLEM_CANCELLING">
      There was a problem canceling the meeting. Please try again later.
    </ng-container>
  </div>
  } }
</div>
